// eslint-disable-next-line import/prefer-default-export
export const COMMON_PROPS_SELECT = {
  classExtra: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  },
  nameRef: {
    type: String,
    required: true,
    default: '',
  },
  ruleFormRef: {
    type: Object,
    default: () => ({}),
  },
  value: {
    default: '',
  },
  errorResponse: {
    type: String,
    default: '',
  },
  tabindex: {
    type: Number,
  },
  showLabel: {
    type: Boolean,
    default: true,
  },
  dense: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: 'LABEL',
  },
  required: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  filterable: {
    type: Boolean,
    default: false,
  },
  remote: {
    type: Boolean,
    default: false,
  },
  popperClass: {
    type: String,
    default: '',
  },
  reserveKeyword: {
    type: Boolean,
    default: false,
  },
  automaticDropdown: {
    type: Boolean,
    default: false,
  },
  isFullWidth: {
    type: Boolean,
    default: false,
  },
  multipleLimit: {
    type: Number,
  },
  clearable: {
    type: Boolean,
    default: true,
  },
  keyLabel: {
    type: String,
    default: '',
  },
  keyValue: {
    type: String,
    default: '',
  },
  outlined: {
    type: Boolean,
    default: false,
  },
  eventModel: {
    type: [String, Boolean, Array],
    default: '',
  },
};
